import styled from "styled-components"
import { Link } from "react-router-dom"
import { mobile, mobilePortrait, tablet } from "../../Responsive"

export const Container = styled.div`
   background-color: ${({ theme }) => theme.body};
`

export const Wrapper = styled.div`
   margin-top: 100px;
   padding: 20px;
   min-height: 85vh;
   display: flex;
   flex-direction: column;
   align-items: center;

   ${tablet({ marginTop: "80px" })}
   ${mobile({ marginTop: "60px", padding: "10px" })}
    ${mobilePortrait({ marginTop: "40px" })}
`

export const Header = styled.div`
   border: 1.5px solid var(--secondary);
   border-radius: 10px;
   margin-top: 20px;
   padding: 20px;
   width: 90vw;
`

export const Title = styled.h1`
   font-weight: 200;
   margin-bottom: 20px;
`

export const Display = styled.div`
   display: flex;
   justify-content: space-between;

   ${tablet({ flexDirection: "column" })}
`

export const Column = styled.div`
   display: flex;
   flex-direction: column;
   max-width: 400px;
   margin-top: 10px;

   ${tablet({ maxWidth: "350px" })}
`

export const InfoItem = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 5px;

   ${mobile({ flexDirection: "column", alignItems: "flex-start" })}
`

export const InfoLabel = styled.span`
   font-size: var(--fontS);
   font-weight: 600;
   margin: 5px;
`

export const Info = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   background-color: ${({ theme }) => theme.body};
   font-size: var(--fontS);
   border: none;
   border-bottom: 1px solid var(--primary);
   border-right: 1px solid var(--primary);
   border-radius: 5px;
   min-height: 30px;
   width: 250px;
   padding: 5px;

   ${tablet({ width: "200px" })}
`

export const StyledLink = styled(Link)`
   text-decoration: none;
   color: inherit;
   cursor: pointer;
`
